import {
	newsConstants
}from "./constants"
import {
	defAction
}from "../../../helpers/defaultAction"
import api from "./api"
import downloadFile from "../../../helpers/downloadFile"

export const newsActions = {
	createNews,
	getNews,
	downloadNewsFile,
	changeNews,
	deleteNews,
	getOneNews,
	restoreNews,
	getAllNews,
	clear
}

function changeNews(values){
	const dispatchObj = {
		constants : newsConstants.changeNews,
		service   : {
			func   : api.changeNews,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function deleteNews(values){
	const dispatchObj = {
		constants : newsConstants.deleteNews,
		service   : {
			func   : api.deleteNews,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function createNews(values){
	const dispatchObj = {
		constants : newsConstants.createNews,
		service   : {
			func   : api.createNews,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getNews(values){
	const dispatchObj = {
		constants : newsConstants.getNews,
		service   : {
			func   : api.getNews,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getOneNews(values){
	const dispatchObj = {
		constants : newsConstants.getOneNews,
		service   : {
			func   : api.getOneNews,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function downloadNewsFile(values){
	const dispatchObj = {
		constants : newsConstants.downloadFile,
		service   : {
			func   : api.downloadNewsFile,
			params : values
		},
		sucFunction: (res) => downloadFile(res, values?.name)
	}
	return defAction(dispatchObj)
}

function restoreNews(values){
	const dispatchObj = {
		constants : newsConstants.restoreNews,
		service   : {
			func   : api.restoreNews,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getAllNews(values){
	const dispatchObj = {
		constants : newsConstants.getAllNews,
		service   : {
			func   : api.getAllNews,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function clear(){
	return (dispatch) => dispatch({
		type: newsConstants.clear
	})
}